<form class="filter-panel row align-items-end" [formGroup]="form">
    <div class="col-12 col-md-auto">
        <ui-calendar-range-control
            [dateFormat]="calendarFormat"
            [formControlName]="invoiceFormField.Date"
            [label]="'global.labels.date' | translate" />
    </div>

    <div class="col-12 col-lg-auto mt-6">
        <ui-button [disabled]="pending" [label]="'global.actions.submit' | translate" (handlerClick)="handlerSubmit()" />
    </div>
</form>
